import { FC, ReactNode, useRef, useState } from 'react';
import styles from './MobileMenuButton.module.css';
import { Icon, IconButton } from '@kpa/kul';
import Navigation from '../Navigation/Navigation';
import HeaderExternalSiteLinks from './HeaderExternalSiteLinks';
import Logout from './Logout';

interface IMobileMenuButton {
  children?: ReactNode;
}

const MobileMenuButton: FC<IMobileMenuButton> = ({ children }): ReactNode => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleEvent = () => {
    if (dialogRef.current?.open) {
      dialogRef.current.setAttribute('hidden', 'true');
      dialogRef.current?.close();
      setIsExpanded(false);
    }
    else if (!dialogRef.current?.open) {
      dialogRef.current?.removeAttribute('hidden');
      dialogRef.current?.showModal();
      setIsExpanded(true);
    }
  };

  return (
    <>

      <div className={styles.container}>

        <button className={styles.buttonOpen} onClick={handleEvent} aria-expanded={isExpanded} aria-label="Öppna meny">
          <Icon color="backgroundPrimary" name="IconMenu" size="small" />
          Meny
          {children}
        </button>

      </div>

      <dialog aria-modal="true" className={styles.dialog} ref={dialogRef} onCancel={handleEvent} hidden={!isExpanded}>
        <IconButton className={styles.buttonClose} variant="navigation" icon="IconClose" ariaLabel="Stäng meny" onClick={handleEvent} />
        <header className={styles.header}>
          <HeaderExternalSiteLinks mobile={true}></HeaderExternalSiteLinks>
        </header>
        <Navigation callback={handleEvent}></Navigation>
        <footer className={styles.footer}>
          <Logout></Logout>
        </footer>
      </dialog>

    </>
  );
};

export default MobileMenuButton;
